<div class="ig-row-action-buttons-container"
     [class.loading]="isLoading"
     [class.showing]="actions.isShowing"
     [class.hiding]="!actions.isShowing"
     (mouseenter)="actions.show()"
     (mouseleave)="actions.hide()"
     (click)="onClick($event)"
     data-testId="container">
    <div class="row-spinner-cover"
         [class.showing]="isLoading"
         [hidden]="false">
        <ig-spinner></ig-spinner>
    </div>
    <ig-actions #actions
                class="ig-row-action-buttons hide-on-mobile"
                [hidden]="isLoading"
                [toggleByParent]="true">
        <ng-content></ng-content>
    </ig-actions>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/row.action.buttons/row.action.buttons.component.html